module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_11.ec9bea3a.mp3";